/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/jsx-no-literals */
// This page is used for development purposes only.

import { RootLayout } from '@/components/layout/_root/root.layout';
import Button from '@/components/ui/button/button.component';
import { Textarea } from '@/components/ui/textarea/textarea.component';
import { useState } from 'react';
import { Link } from 'react-router-dom';

// It is included in the production build. But if needed, it can be removed from the production build.
export const DevPage = () => {
  const [frontendError, setFrontendError] = useState<string>('');
  const [errored, setErrored] = useState<boolean>(false);
  const throwFrontendError = () => {
    if (frontendError === '') return;
    setErrored(true);
  };

  if (errored) throw new Error(frontendError);
  return (
    <RootLayout>
      <div className="mt-[96px] mx-18 mb-[60px]">
        <div className="flex flex-col gap-y-4">
          <div className="bg-light-gray px-4 py-3 flex flex-col rounded text-center gap-y-2">
            <p className="typo-primary-400">
              🛠️ Heads Up! You&apos;ve stumbled upon our development playground! This page is where we test new
              functionalities and perfect our features. If you&apos;re looking for the complete experience, it’s best to
              head back to the main site. However, if you&apos;re curious about what we&apos;re working on, feel free to
              explore!
            </p>
            <p className="typo-primary-400">
              Need to get back? Click{' '}
              <Link className="underline" to="/products">
                here
              </Link>{' '}
              to return to the homepage. Thanks for your understanding!
            </p>
          </div>
          <div className="flex flex-col gap-y-4">
            <h2>Handling frontend errors</h2>
            <div className="bg-light-gray px-4 py-3 flex flex-col rounded gap-y-2">
              <Textarea
                data-testid="dev-frontend-error-textarea"
                value={frontendError}
                placeholder="Enter your error message here"
                onChange={(e) => setFrontendError(e.target.value)}
              />
              <Button data-testid="dev-frontend-error-submit" onClick={throwFrontendError} variant="default">
                Throw error
              </Button>
            </div>
          </div>
        </div>
      </div>
    </RootLayout>
  );
};
